// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"ErrorPage_errorContainer__2aZU8"};